import { number } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';
import { ValueMeasurement } from '@/app/form/fields/material/helpers/value-measurement';
import { MeasurementSystem } from '@/app/measurement-systems/model';

export const classificationTemperatureSchema = (measurementSystem: MeasurementSystem) =>
  number()
    .moreThan(measurementSystem === MeasurementSystem.METRIC ? -50 : -58)
    .max(measurementSystem === MeasurementSystem.METRIC ? 2200 : 3992)
    .label('Classification Temperature');

export const ClassificationTemperatureHookFormField = (props: FieldInputProps) => (
  <HookFormField.Input
    label="Classification Temperature"
    extendProps={(props) => ({
      ...props,
      endSlot: (
        <ValueMeasurement
          imperial={<>&deg;F</>}
          metric={<>&deg;C</>}
        />
      )
    })}
    {...props}
  />
);